export default "__VITE_ASSET__BXB4JBI5__"